import React from 'react';
import PropTypes from 'prop-types';

const SightingLocation = ({coords }) => {
  let src = "https://maps.google.com/maps?q='"+coords.latitude+"','"+coords.longitude+"'&hl=en;z=14&amp;output=embed"
  src="https://www.google.com/maps/embed/v1/place?q="+coords.latitude+","+coords.longitude+"&key=AIzaSyCgAd72q0C09MjOkLUVEG91IJJ2RxYBPVc"
  return (
    <div className="genericPageContainer grey">
      <div className="sighted-location-page-container genericPageWrap">
        <header className="slp-header">
          <h5 className="slph-title">Thank you! You&apos;ve sighted Phil Golding</h5>
          <p className="slph-subtitle">We&apos;ve alerted his contact with your location. In the meantime this information may be useful.</p>
        </header>
        <div className="genericSettingsForm">
          <div className="genericSettingsColumn gsp-left">
            <div className="genericSettingsPanel">
              <h5 className="gsp-title">Wearer Details</h5>
              <div className="gsp-input">
                <p className="gsp-label">Wearer</p>
                <input className="gsp-textinp" value="Phil Golding" readOnly/>
              </div>
              <div className="gsp-input">
                <p className="gsp-label">Contact Number</p>
                <input className="gsp-textinp" value="0XXXXXXXXXX" readOnly/>
              </div>

              <h6 className="gsp-subtitle">Medical Condition</h6>
              <article className="gsp-medical-condition">
                <h6 className="gsp-mc-title">Bronchitis</h6>
                <p className="gsp-mc-note">Ain&apos;t nobody got time for that</p>
              </article>
            </div>
          </div>
          <div className="genericSettingsColumn gsp-right">
            <div className="genericSettingsPanel nopad gsp-left">
              <div className="gsp-innerpad">
                <h5 className="gsp-title">This Sighting</h5>
                <div className="gsp-input">
                  <p className="gsp-label">Time</p>
                  <input className="gsp-textinp" value="12:47" readOnly/>
                </div>
                <div className="gsp-input">
                  <p className="gsp-label">Date</p>
                  <input className="gsp-textinp" value="14/4/1999" readOnly/>
                </div>

                <h6 className="gsp-subtitle">Location</h6>
              </div>
              <iframe className="gsp-map" width="600" height="450" frameBorder="0" src={src} allowFullScreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SightingLocation.propTypes = {
  coords: PropTypes.object.isRequired
};

export default SightingLocation;



// WEBPACK FOOTER //
// ./src/components/sighting/SightingLocation.js